import { blankRelationship, urgeToChat } from '../../sim/relationships.js';
import type { Memory, Npc, Relationship, SleepState } from '../../types.js';
import { pairKey } from '../social.js';
import type { WorldState } from '../useSim.js';
import BioPanel, { type BioTab } from '../BioPanel.js';

const relKey = (a: string, b: string): string => `${a}>${b}`;

export default function GameBioPanel(props: {
  bioNpc: Npc;
  bioTab: BioTab;
  onTab: (t: BioTab) => void;
  sleep: SleepState;
  bedSecs: number;
  wakeAt: number;
  npcs: Npc[];
  w: WorldState | null;
  rels: Map<string, Relationship>;
  memsOf: (a: string, b: string) => Memory[];
  longOf: (a: string, b: string) => string;
  chatRecency: Map<string, number>;
  onClose: () => void;
}): JSX.Element {
  const p = props;
  return (
    <div className="bio-overlay">
    <BioPanel
      key={p.bioNpc.id}
      npc={p.bioNpc}
      tab={p.bioTab}
      onTab={p.onTab}
      sleep={p.sleep}
      bedSecs={p.bedSecs}
      wakeAt={p.wakeAt}
      rels={p.npcs
        .filter((n) => n.id !== p.bioNpc.id)
        .map((n) => {
          const rel = p.rels.get(relKey(p.bioNpc.id, n.id)) ?? blankRelationship(p.bioNpc.id, n.id);
          const rtSelf = p.w?.runtime.find((r) => r.npcId === p.bioNpc.id);
          const rtOther = p.w?.runtime.find((r) => r.npcId === n.id);
          const dist = rtSelf && rtOther ? Math.hypot(rtSelf.x - rtOther.x, rtSelf.y - rtOther.y) : 300;
          const last = p.chatRecency.get(pairKey(p.bioNpc.id, n.id));
          return {
            other: `${n.firstName} ${n.lastName}`,
            rel,
            mems: p.memsOf(p.bioNpc.id, n.id),
            longterm: p.longOf(p.bioNpc.id, n.id),
            urge: urgeToChat(rel.affinity, rel.attraction, last == null || !p.w ? null : p.w.now - last, dist),
          };
        })}
      onClose={p.onClose}
    />
    </div>
  );
}
